import _ from "lodash";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import IntlMessages from "util/intlMessages";
import Select from "react-select";

const TimeScalesSelector = (props) => {
  const { dynamicScales } = props.envStore;
  const { name = "timeScale", setValue } = props;

  const options = () =>
    _.map(dynamicScales, (value) => {
      return { value, label: <IntlMessages id={`TimeScales.${value}`} /> };
    });

  const onChangeHandler = (selectedOptions) => {
    const value = selectedOptions.value;
    const target = { name, value };
    setValue({ target });
  };

  return (
    <Select
      isMulti={false}
      name={name}
      value={
        props.value ? { value: props.value, label: <IntlMessages id={`TimeScales.${props.value}`} /> } : null
      }
      options={options()}
      placeholder={<IntlMessages id={"TimeScales"} />}
      onChange={onChangeHandler}
    />
  );
};

const mapStateToProps = (state) => ({
  envStore: state.api.env,
});

export default connect(mapStateToProps, {})(TimeScalesSelector);
